import React, { useEffect, useState, useRef } from "react";
const Count = () =>{
  const [count, setCount] = useState(0);
  const [builcount, builsetCount] = useState(1);
  const [houscount, houssetCount] = useState(1);
  const containerRef = useRef(null);

  useEffect(() => {
    let interval;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          interval = setInterval(() => {
            if (count < 600) {
              setCount((prevCount) => prevCount + 2);
            } else {
              clearInterval(interval); 
            }
          }, 1);
        }
      });
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
      clearInterval(interval); // Clear interval when component unmounts
    };
  }, [count]);

  useEffect(() => {
    let interval;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          interval = setInterval(() => {
            if (builcount < 350) {
              builsetCount((prevCount) => prevCount + 1);
            } else {
              clearInterval(interval); // Stop the interval when count reaches 600
            }
          }, 1);
        }
      });
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
      clearInterval(interval); // Clear interval when component unmounts
    };
  }, [builcount]);

  useEffect(() => {
    let interval;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          interval = setInterval(() => {
            if (houscount < 250) {
              houssetCount((prevCount) => prevCount + 1);
            } else {
              clearInterval(interval);
            }
          }, 1);
        }
      });
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
      clearInterval(interval); // Clear interval when component unmounts
    };
  }, [houscount]);
    
return(
    <>
    <section  ref={containerRef}  id="counts" className="counts">
      <div className="container-xxl" >

        <div className="row no-gutters">
          <div className="image col-xl-5 d-flex align-items-stretch justify-content-center justify-content-lg-start"></div>
          <div className="col-xl-7 ps-4 ps-lg-5 pe-4 pe-lg-1 d-flex align-items-stretch" >
            <div className="content d-flex flex-column justify-content-center">
              <h3>Numbers and figures</h3>
              {/* <p>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Duis aute irure dolor in reprehenderit
              </p> */}
              <div className="row">
                <div className="col-md-6 d-md-flex align-items-md-stretch">
                  <div className="count-box">
                    <i className="bi bi-emoji-smile"></i>
                    <span >{count}</span>
                    <p><strong>Happy Clients</strong>.</p>
                  </div>
                </div>

                <div className="col-md-6 d-md-flex align-items-md-stretch">
                  <div className="count-box">
                    <i className="bi bi-journal-richtext"></i>
                    <span >{builcount}</span>
                    <p><strong>Projects</strong></p>
                  </div>
                </div>

                <div className="col-md-6 d-md-flex align-items-md-stretch">
                  <div className="count-box">
                    <i className="bi bi-clock"></i>
                    <span >15</span>
                    <p><strong>Years of experience</strong></p>
                  </div>
                </div>

                <div className="col-md-6 d-md-flex align-items-md-stretch">
                  <div className="count-box">
                    <i className="bi bi-award"></i>
                    <span >{houscount}</span>
                    <p><strong>Awards</strong></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
  </section>
 </>
);

}
export default Count;